import { createFileRoute, Outlet } from '@tanstack/react-router'

function InboxLayout() {
  return <Outlet />
}

export const Route = createFileRoute('/_authed/_user/inbox')({
  component: InboxLayout,
  beforeLoad: () => ({
    getTitle: () => 'Inbox',
  }),
})
